export default function PageLoading() {
  return (
    <div className="min-h-screen bg-[#0d1b2a] flex flex-col items-center justify-center">
      <div className="text-center">
        <div className="flex items-center justify-center gap-3 mb-6">
          <div className="w-10 h-10 flex items-center justify-center bg-[#c8881a] rounded-sm">
            <span className="text-white font-bold text-lg tracking-wide">K</span>
          </div>
          <span className="text-white font-bold text-xl tracking-wider">
            KIVE <span className="text-[#c8881a]">SARL</span>
          </span>
        </div>
        <div className="w-32 h-0.5 bg-white/10 rounded-full overflow-hidden mx-auto">
          <div className="h-full bg-[#c8881a] animate-pulse rounded-full" style={{ width: "60%" }}></div>
        </div>
        <p className="text-white/40 text-xs mt-4 tracking-wide">
          Loading KIVE SARL Yaoundé Cameroun...
        </p>
      </div>
    </div>
  );
}